import React from 'react';
import { Typography } from 'antd';
const { Title } = Typography;

const TunnelGRE = (props) => {
    return (
        <>
            <Title>Page Under Construction.</Title>
        </>
    );
};

export default TunnelGRE;
